import { getRandomBetween } from "../utils";

export default function createKozUniversityQueen() {
  const pattern = getRandomBetween(0.7, 0.9);

  const layingVigor = getRandomBetween(0.3, 0.7);
  const honey = getRandomBetween(0.5, 0.8);
  const diseaseResistance = getRandomBetween(0.6, 0.9);
  const swarmTendency = getRandomBetween(0.5, 0.99);
  const aggression = getRandomBetween(0.4, 0.8);
  const miteResistance = getRandomBetween(0.7, 0.9);
  const overWinter = getRandomBetween(0.6, 0.9);

  let queenStats = {
    haveQueen: true,
    layingVigor: layingVigor,
    pattern: pattern,
    honey: honey,
    diseaseResistance: diseaseResistance,
    swarmTendency: swarmTendency,
    droneTendency: 0.05,
    aggression: aggression,
    virgin: false,
    laying: true,
    miteResistance: miteResistance,
    overwinter: overWinter,
    breed: "Koz University",
    birth: new Date().getTime(),
  };
  return queenStats;
}
